var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center fill-height"},[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.openLoginModal}},[_vm._v(" Login ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }